import React from "react"
import { IconMenu, IconButton, FontIcon, MenuItem } from "material-ui"
import strings from "../../../localization/strings"
import { IUserDocument } from "../../../models"
import { CSVLink } from "react-csv"
import { grey700 } from "material-ui/styles/colors"
import * as hierarchyHelper from "../../../helpers/hierarchyHelper"
import * as permissionHelper from "../../../helpers/permissionHelper"

interface IProps {
    reportUsers: IUserDocument[]
}

const AccountUsersReport: React.SFC<IProps> = (props: IProps) => {
    const downloadData = [
        [strings.First_Name, strings.Last_Name, strings.Email, strings.External_ID, strings.Owner, strings.Organization_Hierarchy, strings.Role]
    ]
    props.reportUsers.forEach(user => {
        const userRole = permissionHelper.getUserRoleById(user.UserRoleId)
        downloadData.push([user.FirstName, user.LastName, user.Email, user.ExternalId, user.Owner ? strings.Yes : "", hierarchyHelper.getFullyQualifiedLevelNameById(user.OrganizationHierarchyId), userRole ? userRole.Type : ""])
    })

    return (
        <div style={{ marginTop: -10, marginLeft: 5 }}>
            <IconMenu
                style={{ padding: 0 }}
                iconButtonElement={
                    <IconButton data-intercom-target={"AccountUser-Page-Report"} tooltip={strings.Reports}>
                        <FontIcon className="fa fa-file-text itemActionButton" style={{ fontSize: 20 }} />
                    </IconButton>
                }
            >
                <MenuItem
                    data-intercom-target={"AccountUser-Page-Report-Download"}
                    leftIcon={<FontIcon className="fa fa-download" />}
                    children={
                        <CSVLink
                            key="csvlink"
                            data={downloadData}
                            style={{ textDecoration: "none", fontSize: 14, fontWeight: 500, color: grey700, textTransform: "uppercase", padding: 20 }}
                            filename="AccountUserReport.csv"
                        >
                            {strings.Download}
                        </CSVLink>
                    }
                />
            </IconMenu>
        </div>
    )
}

export default AccountUsersReport